class ScrollableImagesWithNavigation extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      changeMobileImageButtons: this.querySelectorAll('[data-change-mobile-image]'),
      mobileImageContainers: this.querySelectorAll('[data-mobile-image-container]'),
      desktopScrollToBlockButtons: this.querySelectorAll('[data-desktop-scroll-to-block]'),
      desktopScrollBlocks: this.querySelectorAll('[data-desktop-scroll-block]'),
      desktopImageContainers: this.querySelectorAll('[data-desktop-image-container]'),
    }

    if (this.elements.changeMobileImageButtons) {
      this.elements.changeMobileImageButtons.forEach((button) => {
        button.addEventListener('click', this.changeMobileImage.bind(this));
      });
    }

    if (this.elements.desktopScrollBlocks) {
      this.elements.desktopScrollBlocks.forEach((block) => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.changeActiveDesktopBlock(block);
            }
          });
        }, { threshold: [0.5], rootMargin: '0px 0px 0px 0px' });

        observer.observe(block);
      });
    }
  }

  changeMobileImage(event) {
    event.preventDefault();
    const {currentTarget} = event;
    const targetId = currentTarget.dataset.changeMobileImage;

    this.elements.changeMobileImageButtons.forEach((button) => {
      button.setAttribute('aria-active', button == currentTarget);
    });

    this.elements.mobileImageContainers.forEach((container) => {
      container.setAttribute('aria-active', container.id == targetId);
    });
  }

  changeActiveDesktopBlock(block) {
    const blockId = block.dataset.blockId;

    this.elements.desktopScrollToBlockButtons.forEach((button) => {
      const buttonBlockId = button.dataset.blockId;
      button.setAttribute('aria-active', buttonBlockId == blockId);
    });

    this.elements.desktopImageContainers.forEach((container) => {
      const containerBlockId = container.dataset.blockId;
      container.setAttribute('aria-active', containerBlockId == blockId);
    });
  }
}

customElements.define('scrollable-images-with-navigation', ScrollableImagesWithNavigation);